<div class="toast-container" aria-live="polite">
  @for (toast of toasts(); track toast.id) {
  <div class="toast toast--{{ toast.variant }}" [attr.role]="toast.variant === 'error' ? 'alert' : 'status'">
    <div class="toast__icon">
      <ng-glyph [name]="getIcon(toast.variant)"></ng-glyph>
    </div>
    <div class="toast__message">{{ toast.message }}</div>
    <button class="toast__close" type="button" (click)="dismiss(toast.id)" aria-label="Dismiss notification">
      <ng-glyph name="close"></ng-glyph>
    </button>
  </div>
  }
</div>
